import { render, staticRenderFns } from "./MatrixPersonCard.vue?vue&type=template&id=6d7e1780"
import script from "./MatrixPersonCard.vue?vue&type=script&lang=js"
export * from "./MatrixPersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports